import { useEffect } from "react";

import { cn } from "@/lib/cn";
import { scrollToFormError } from "@/lib/scroll-to-form-error";

type AlertProps = {
  tone?: "error" | "info" | "success";
  title?: string;
  children: string;
  className?: string;
};

export function Alert({ tone = "error", title, children, className }: AlertProps) {
  useEffect(() => {
    if (tone !== "error") return;
    scrollToFormError();
  }, [tone, title, children]);

  return (
    <div
      role="alert"
      data-form-error={tone === "error" ? "" : undefined}
      className={cn(
        "scroll-mt-20 rounded-xl border px-4 py-3 text-sm",
        tone === "error" && "border-danger/20 bg-danger-soft text-danger",
        tone === "info" && "border-brand/20 bg-brand-soft text-brand-strong",
        tone === "success" && "border-success/20 bg-success-soft text-success",
        className,
      )}
    >
      {title ? <p className="font-semibold">{title}</p> : null}
      <p className={cn(title && "mt-1")}>{children}</p>
    </div>
  );
}
